export const editMutations = <const>{
	POKLADNA_NAKLADOVE_STEDISKO_SELECT_MAPPER: 'POKLADNA_NAKLADOVE_STEDISKO_SELECT_MAPPER',
};
